import React from 'react';
import { useDispatch } from 'react-redux';
import {
  changeAssignedInchargeAdminId,
  changeAssignInchargeModalVisibility,
} from '../../../store/memberSlice';
import { InChargeAdminOnMember } from '../../../types/apiGeneratedTypes';

type Props = {
  inchargeData: InChargeAdminOnMember | null | undefined;
};

const AssignedIncharge = ({ inchargeData }: Props) => {
  const dispatch = useDispatch();

  return inchargeData?.user_id ? (
    <div
      className='assigned-doctor assigned-incharge'
      onClick={() => {
        dispatch(changeAssignedInchargeAdminId(inchargeData.user_id));
        dispatch(changeAssignInchargeModalVisibility(true));
      }}
    >
      <div className='doctor-avatar incharge-avatar-placeholder'>
        {`${inchargeData.first_name?.[0] ?? ''}${inchargeData.last_name?.[0] ?? ''}`.toUpperCase()}
      </div>
      <div className='doctor-name-wrapper'>
        <div className='doctor-name'>{`${inchargeData.first_name} ${inchargeData.last_name}`}</div>
        <span className='name-info'>Assigned Incharge</span>
      </div>
    </div>
  ) : (
    <div className='main-member-info'>
      <div className='divider'></div>
      <div className='member-info'>
        <div className='info-label'>Incharge</div>
        <div className='info-value address'>
          <div>
            <div
              className='set-address'
              onClick={() => {
                dispatch(changeAssignedInchargeAdminId(null));
                dispatch(changeAssignInchargeModalVisibility(true));
              }}
            >
              Assign Incharge
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignedIncharge;
